import { render, staticRenderFns } from "./advert-similar.vue?vue&type=template&id=04d96dc4"
import script from "./advert-similar.vue?vue&type=script&lang=ts"
export * from "./advert-similar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports